import type { TableSeries } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { BadgeItem } from '../../../../components/generic/BadgeItem';
import type { UseTableReturn } from '../../hooks/useTable';
import { METHOD_TYPE_OPTIONS_MAP } from '../../utils';

interface Props {
  table: UseTableReturn;
  series: TableSeries;
  onClick: () => void;
}

export const TableSeriesButtonGroup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { table, series, onClick } = props;

  const onRemove = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    table.onRemoveSeries(series.id);
  };

  const methodTypeOption = METHOD_TYPE_OPTIONS_MAP[series.source.method];

  return (
    <ChakraV3.ButtonGroup ref={ref} size='sm' attached variant='outline' onClick={onClick}>
      <ChakraV3.Button px={1.5}>
        <BadgeItem label={methodTypeOption.label} color={methodTypeOption.color} />
      </ChakraV3.Button>
      <ChakraV3.IconButton onClick={onRemove} aria-label='Remove method'>
        <FaTimes />
      </ChakraV3.IconButton>
    </ChakraV3.ButtonGroup>
  );
});
